import React from "react";
import { Card, Avatar, Button } from "antd";

export default class CardHeader extends React.Component {
  render() {
    const { icon, title, buttonTitle, onActionClicked, ghost } = this.props;
    return (
      <div className="d-flex flex-row align-items-center mb-2">
        <i className={`icon icon-${icon}`} style={{ fontSize: "18px" }} />
        <h5 className="my-0">{title}</h5>
        {buttonTitle ? (
          <div className="justify-content-end text-right flex-fill">
            <Button className="ant-btn-secondary" onClick={onActionClicked}>
              {buttonTitle}
            </Button>
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard/CardHeader.js